import {
  blackCheckCircle,
  greenCheckCircle,
  notificationIcon,
  supportBlackIcon,
} from "~/assets/assets";
import { Spinner } from "~/widgets/spinner";
import { openIntercom } from "~/utils/third_party/intercom";
import { ButtonRegular } from "~/widgets/button";
import { HubbleRoute, PageAlignment, pushPage } from "~/shared_states/modal";
import { HubbleBranding } from "~/widgets/branding";
import { toRupees } from "~/utils/number";
import Home from "../home/home";

export function HighWaitingTimeBankTransfer(props: { amount: number }) {
  return (
    <div class="relative flex h-full w-full flex-col items-center justify-start bg-baseTertiaryLight">
      <div class="mt-12 flex flex-col items-center justify-center gap-1">
        <p class="text-mediumBold uppercase text-textDark">Bank transfer</p>
        <p class="text-medium text-textNormal">
          Amount: {toRupees(props.amount)}
        </p>
      </div>
      <div class="mt-24 flex flex-col items-center justify-center gap-4">
        <div class="flex aspect-square h-14 w-14 items-center justify-center">
          <Spinner />
        </div>
        <div class="flex  flex-col items-center justify-center gap-2">
          <p class="text-center text-h2 text-textDark">
            It’s taking longer <br /> than expected
          </p>
          <p class="text-center text-medium text-textNormal">
            Money usually get transferred right away, but on rare <br />{" "}
            occasions, they could take up to 5 days.
          </p>
        </div>
        <div class="flex items-center justify-center gap-2">
          <img src={notificationIcon} alt="" />{" "}
          <p class="text-mediumBold text-textDark">
            We’ll notify you once transferred
          </p>
        </div>
      </div>
      <div class="mt-16 flex h-[100px] w-[327px] flex-col items-center justify-between gap-3 rounded-2xl bg-baseTertiaryMedium px-5 py-6">
        <div class="flex w-full items-center justify-start gap-2">
          <img src={blackCheckCircle} alt="" />
          <p class="text-mediumBold text-textDark">
            Check status in menu - Transactions
          </p>
        </div>
        <div class="flex w-full items-center justify-start gap-2">
          <img src={greenCheckCircle} alt="" />
          <p class="text-mediumBold text-textDark">
            Full refund assured if this fails
          </p>
        </div>
      </div>
      <div class="absolute bottom-4 left-4 right-4">
        <div class="flex items-center justify-center gap-1.5">
          <img src={supportBlackIcon} alt="" />
          <p
            onClick={() => {
              openIntercom();
            }}
            class="text-mediumBold text-textDark underline [text-underline-position:from-font]"
          >
            Contact support
          </p>
        </div>
        <ButtonRegular
          isEnabled={true}
          onClick={() => {
            pushPage(
              () => <Home />,
              {
                isModal: false,
                alignment: PageAlignment.bottom,
                offset: { top: 20, right: 20 },
              },
              HubbleRoute.HOME
            );
          }}
          class="mt-4 w-full"
        >
          Got it
        </ButtonRegular>
        <HubbleBranding class="mt-3 border-none" />
      </div>
    </div>
  );
}
